function clickLabelForSize(value) {
  if (!value) return;
  const label = document.querySelector(`label[data-original-size="${value}"]`);
  if (label) {
    const event = new Event('click', { bubbles: true, cancelable: true });
    label.dispatchEvent(event);
    const inputId = label.getAttribute('for');
    if (inputId) {
      const input = document.getElementById(inputId);
      if (input) input.click();
    }
  } else {
    console.warn('⚠️ Label not found for recommended size:', value);
  }
}

window._faslet = window._faslet || {};

window._faslet.onResult = (result, resultType) => {
  const recommendedSize = result.label;

  if (recommendedSize) {
    clickLabelForSize(recommendedSize);
  }
};


const fasletApp = document.querySelector('faslet-app');

const observer = new MutationObserver((mutations, observer) => {
  
  if(fasletApp && fasletApp.shadowRoot){
    const shadowRoot = fasletApp.shadowRoot;
    
    const style = document.createElement('style');
    style.textContent = `

@media (max-width: 800px){
      .popup-inner {
        padding-bottom: 30px !important;
      }
}
    `;
    shadowRoot.appendChild(style);

    observer.disconnect();
  }
});

if (fasletApp){
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  })
}

